import React, { useEffect, useState } from 'react';
import { Footer } from '../components/Footer';
import { Modal } from '../components/Modal';
import { PrivacyPolicyContent, ContactUsContent, TermsOfUseContent } from '../components/ModalContent';
export function OptIn() {
  const [modalType, setModalType] = useState<'privacy' | 'contact' | 'terms' | null>(null);
  const [pixelFired, setPixelFired] = useState(false);
  const [postbackFired, setPostbackFired] = useState(false);
  const [streetAddress, setStreetAddress] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  useEffect(() => {
    // Get bemobclick from localStorage
    const cid = localStorage.getItem('bemobclick');
    if (cid) {
      // Fire the postback
      setPostbackFired(true);
    }
    // Get parameters from localStorage instead of URL
    const ts = localStorage.getItem('ts');
    const targetingdomainid = localStorage.getItem('targetingdomainid');
    const keywordid = localStorage.getItem('keywordid');
    if (ts) {
      setStreetAddress(ts);
    }
    if (targetingdomainid) {
      setCompanyName(targetingdomainid);
    }
    if (keywordid) {
      setNeighborhood(keywordid);
    }
  }, []);
  const handleOpenModal = (type: 'privacy' | 'contact' | 'terms') => {
    setModalType(type);
  };
  const handleCloseModal = () => {
    setModalType(null);
  };
  const handleFormSubmit = () => {
    setPixelFired(true);
  };
  const getModalContent = () => {
    switch (modalType) {
      case 'privacy':
        return {
          title: 'Privacy Policy',
          content: <PrivacyPolicyContent data-id="element-213" />
        };
      case 'contact':
        return {
          title: 'Contact Us',
          content: <ContactUsContent data-id="element-214" />
        };
      case 'terms':
        return {
          title: 'Terms of Use',
          content: <TermsOfUseContent data-id="element-215" />
        };
      default:
        return {
          title: '',
          content: null
        };
    }
  };
  const {
    title,
    content
  } = getModalContent();
  return <div className="w-full min-h-screen font-['Open_Sans'] bg-gradient-to-br from-[#0039a6] to-[#6a11cb] flex flex-col" data-id="element-216">
      <style data-id="element-217">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&family=Open+Sans:wght@400;600&display=swap');
          .submit-button {
            transition: all 0.3s ease;
          }
          .submit-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
          }
        `}
      </style>
      {/* Postback Pixel - fires on page load if bemobclick exists */}
      {postbackFired && <img src={`http://jgvxy.bemobtrk.com/postback?cid=${localStorage.getItem('bemobclick')}&payout=0`} width="1" height="1" alt="" style={{
      position: 'absolute'
    }} data-id="element-218" />}
      {/* Conversion Pixel - fires when form is submitted */}
      {pixelFired && <img src="https://go.trkrgodom.com/conversion.gif?cid=OPTIONAL&payout=OPTIONAL&txid=OPTIONAL" width="1" height="1" alt="" style={{
      position: 'absolute'
    }} data-id="element-219" />}
      <div className="px-4 py-6 flex-grow" data-id="element-220">
        {/* Logo */}
        <div className="text-center mb-12" data-id="element-221">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2TqMEYVHuTPuBcgwmU1HgU/FINANCE_TIME_%282%29.png" alt="Finance-Time" className="h-8 md:h-8 mx-auto" data-id="element-222" />
        </div>
        <div className="max-w-2xl mx-auto" data-id="element-223">
          {/* Success indicator */}
          <div className="text-center mb-8" data-id="element-224">
            <div className="w-20 h-20 bg-[#00C851] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-225">
              <span className="text-5xl" data-id="element-226">✓</span>
            </div>
            <h1 className="text-3xl md:text-4xl font-['Montserrat'] font-bold text-white mb-4" data-id="element-227">
              You're Almost There!
            </h1>
            <p className="text-lg text-white/90 max-w-xl mx-auto" data-id="element-228">
              Enter your email to receive your personalized access to get your
              credit score report and improvement tips.
            </p>
          </div>
          {/* Form Card */}
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12" data-id="element-229">
            <form id="systemeForm" method="post" action="https://systeme.io/embedded/34779178/subscription" data-id="element-230">
              <div className="mb-6" data-id="element-231">
                <input type="text" name="email" id="email" required placeholder="Enter your email address" className="w-full px-6 py-4 text-lg border-2 border-gray-200 rounded-xl focus:border-[#00C851] focus:outline-none transition-colors" data-id="element-232" />
              </div>
              {/* Hidden fields for URL parameters */}
              {streetAddress && <input type="hidden" name="street_address" value={streetAddress} data-id="element-233" />}
              {companyName && <input type="hidden" name="company_name" value={companyName} data-id="element-234" />}
              {neighborhood && <input type="hidden" name="neighborhood" value={neighborhood} data-id="element-235" />}
              <div className="f-row" data-id="element-236">
                <button type="submit" onClick={handleFormSubmit} className="submit-button btn w-full bg-[#00C851] text-white text-lg md:text-xl font-semibold px-10 py-5 rounded-xl hover:bg-[#00b347] shadow-lg" data-id="element-237">
                  Get My Free Credit Report
                </button>
              </div>
            </form>
            <p className="text-sm text-gray-500 text-center mt-6" data-id="element-238">
              By subscribing, you agree to receive emails from Finance-Time. You
              can unsubscribe at any time.
            </p>
          </div>
          {/* Trust indicators */}
          <div className="mt-8 text-center" data-id="element-239">
            <div className="flex flex-wrap justify-center gap-6 text-white/80 text-sm" data-id="element-240">
              <div className="flex items-center gap-2" data-id="element-241">
                <span data-id="element-242">🔒</span>
                <span data-id="element-243">Secure & Encrypted</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-244">
                <span data-id="element-245">✉️</span>
                <span data-id="element-246">No Spam</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-247">
                <span data-id="element-248">🎯</span>
                <span data-id="element-249">100% Free</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <Footer onOpenModal={handleOpenModal} data-id="element-250" />
      {/* Modal */}
      <Modal isOpen={modalType !== null} onClose={handleCloseModal} title={title} data-id="element-251">
        {content}
      </Modal>
    </div>;
}